import { render, staticRenderFns } from "./QuestionDropDownBox.vue?vue&type=template&id=8b0a0628&scoped=true&"
import script from "./QuestionDropDownBox.vue?vue&type=script&lang=js&"
export * from "./QuestionDropDownBox.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDropDownBox.vue?vue&type=style&index=0&id=8b0a0628&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0a0628",
  null
  
)

export default component.exports